(function() {
    "use strict";

    angular.module("app.layout").directive("radioDesign", dir);

    /* @ngInject */
    function dir($rootScope) {
        var conf = {
            templateUrl: "radio-design.tpl",
            bindToController: true,
            controller: ctrl,
            controllerAs: "vm",
            link: link,
            restrict: "E",
            require: "?ngModel",
            scope: {
                name: "@",
                choices: "=",
                placeholder: "="
            }
        };
        return conf;

        function link(scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            } // do nothing if no ng-model
            scope.vm.selected = null;
            scope.select = function(ridx) {
                scope.vm.selected = ridx;
                ngModel.$setViewValue(scope.vm.choices[ridx]);
                $rootScope.$broadcast('pieRadioDesignChangeEvent', {
                    name: scope.vm.name,
                    value: angular.copy(scope.vm.choices[ridx])
                });
            };
            setTimeout(function() {
                return scope.select(0);
            }, 10);
        }
    }

    /* @ngInject */
    function ctrl($scope, $http, $cookies) {}
})();
